import { render, staticRenderFns } from "./MidiaHorizontalTelaCheia.vue?vue&type=template&id=3d676dfc&scoped=true"
import script from "./MidiaHorizontalTelaCheia.vue?vue&type=script&lang=js"
export * from "./MidiaHorizontalTelaCheia.vue?vue&type=script&lang=js"
import style0 from "./MidiaHorizontalTelaCheia.vue?vue&type=style&index=0&id=3d676dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d676dfc",
  null
  
)

export default component.exports